module.exports = __webpack_public_path__ + "img/phone-login-icon.1c6dc754.svg";